var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Accordion, AccordionDetails, AccordionSummary, Grid, IconButton, Typography, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { t } from 'i18next';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { UploadImage } from '../../../api/api';
import { CheckRepeatUrl, CustomerComplaintUrl, CustomerVoiceToJobItemUrl, JCCustomerVoicesURL, USER_PROFILE_DATA, VoiceUrl, getDownloadPreJobCardDocumentAttachmentUrl, getPreJobCardDocumentAttachmentUploadUrl, getSavedJobItemsJobCardUrl, getSavedJobItemsUrl, precheckAttachmentCreateUrl, saveDeclinedCustomerComplaintsUrl } from '../../../api/url';
import { FeaturedIconNew, MoreClickIconSVG } from '../../../assets/customIcons';
import { CalendarIconNew, MovieCreationIcon, PlusGrayIconNew, gramophoneIcon } from '../../../assets/images';
import { AudioPlayer, MuiStack } from '../../../components';
import CustomeAccordian from '../../../components/atoms/customeAccordian';
import { MuiImagePopUp } from '../../../components/atoms/imageDialogBox';
import ViewAllImagePopUp from '../../../components/atoms/viewAllImagePopUp';
import { ImageAudioComponent } from '../../../components/templates/imageAudioComponent';
import TranslateToJobComponent from '../../../components/templates/translateToJob/translateToJobComponent';
import TranslateToJobMessage from '../../../components/templates/translateToJob/translateToJobMessage';
import VehicleDetailsViewJobs from '../../../components/templates/viewJobs/vehicleDetails.viewJobs';
import { APISchema, ESABoxParent, LOCAL_STORAGE_KEYS, Module, isModuleConfig } from '../../../constants';
import { downloadAttachment, setDocDataUpdated, showLoader, showNotification } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { GoogleAnlyticsErrorLog, dateFormate, getCustomerVoiceSectionAttributes, getJobItemsTranslateToJobItems, getTime, sortImagesByTimeStamp } from '../../../utils/utils';
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "24px",
        width: "24px"
    };
});
export default function CustomerComplaintView(props) {
    var _this = this;
    var _preDocumentFetch$dat3, _customerDetailsTrnal3;
    var _a = props.isDisabled, isDisabled = _a === void 0 ? false : _a, renderMainComponent = props.renderMainComponent, requestID = props.requestID, url = props.url, _b = props.isFromAppointment, isFromAppointment = _b === void 0 ? false : _b, disabledConfirmDocument = props.disabledConfirmDocument, _c = props.showInAccordian, showInAccordian = _c === void 0 ? true : _c, apiRequestParam = props.apiRequestParam, apiRequestPayload = props.apiRequestPayload, _d = props.parentModuleDocumentId, parentModuleDocumentId = _d === void 0 ? "" : _d, _e = props.isFromJobCard, isFromJobCard = _e === void 0 ? false : _e, createAndEditFlow = props.createAndEditFlow, IsFromParentAPt = props.IsFromParentAPt, jobCardViewJobsLength = props.jobCardViewJobsLength, vehicleList = props.vehicleList, SystemName = props.SystemName;
    var _f = useState([]), list = _f[0], setList = _f[1];
    var dispatch = useAppDispatch();
    var documentId = useParams().documentId;
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var _g = useState(false), isTranslateToJobClicked = _g[0], setisTranslateToJobChecked = _g[1];
    var _h = useState(false), isTranslateToJobClickedViewJObs = _h[0], setisTranslateToJobCheckedViewJobs = _h[1];
    var _j = useState(false), viewImages = _j[0], setViewImages = _j[1];
    var _k = useState(false), addClick = _k[0], setAddClick = _k[1];
    var _l = useState(), itemCustomerId = _l[0], setItemCustomerId = _l[1];
    var _m = useAppSelector(function (state) { return state.crud; }), customerDetailsTrnalsteToJob = _m.customerDetailsTrnalsteToJob, documentDetailsGetById = _m.documentDetailsGetById, preDocumentFetch = _m.preDocumentFetch, getModuleHeaderCount = _m.getModuleHeaderCount, getStoredJobItems = _m.getStoredJobItems, savedJobItemCreateFlow = _m.savedJobItemCreateFlow, repeatAlertConfiguration = _m.repeatAlertConfiguration;
    var _o = useState(false), openSACommentsPopup = _o[0], setOpenSACommentsPopup = _o[1];
    var _p = useState(false), isDrawerOpen = _p[0], setISDrawerOpen = _p[1];
    var _q = useState(""), imageURL = _q[0], setImageURL = _q[1];
    var customerVoiceSectionDetails = useSelector(function (state) { return state.common; }).customerVoiceSectionDetails;
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    useEffect(function () {
        dispatch(setState({
            key: "customerDetailsTrnalsteToJob",
            value: null
        }));
        if (apiRequestParam === "JobCard") {
            var _documentDetailsGetBy;
            jobCardCustomerDetails();
            customerComplaintJobcard({
                JobCardId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.id
            }, JCCustomerVoicesURL);
        }
        else {
            if (apiRequestPayload && preDocumentFetch.length == 0 && !IsFromParentAPt) {
                customerComplaint(apiRequestPayload, url);
            }
        }
        if ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) == 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) == 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) == 'Update') {
            getJobItems(requestID);
        }
    }, []);
    useEffect(function () {
        var _preDocumentFetch$dat;
        if ((preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat = preDocumentFetch.data) === null || _preDocumentFetch$dat === void 0 ? void 0 : _preDocumentFetch$dat.length) > 0) {
            var _preDocumentFetch$dat2;
            var key = preDocumentFetch.data[0].PreJobCardDocumentName;
            var request = {};
            if (key == APISchema.Inspection) {
                request = {
                    "InspectionId": preDocumentFetch.data[0].PreJobCardDocumentId
                };
            }
            else if (key == APISchema.Appointment) {
                request = {
                    "AppointmentId": preDocumentFetch.data[0].PreJobCardDocumentId
                };
            }
            customerComplaint(request, CustomerComplaintUrl(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat2 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat2 === void 0 ? void 0 : _preDocumentFetch$dat2.PreJobCardDocumentName));
            getJobItems(preDocumentFetch.data[0].PreJobCardDocumentId);
        }
    }, [(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat3 = preDocumentFetch.data) === null || _preDocumentFetch$dat3 === void 0 ? void 0 : _preDocumentFetch$dat3.length) > 0]);
    var getJobItems = function (preJobCardId) { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload, _result$payload2, requestBody, result, _result$payload3, savedCount, _customerDetailsTrnal;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!(customerDetailsTrnalsteToJob !== null && customerDetailsTrnalsteToJob !== void 0 && customerDetailsTrnalsteToJob.data)) return [3 /*break*/, 2];
                    requestBody = {
                        PreJobCardDocumentId: preJobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'customerDetailsTrnalsteToJob',
                            url: getSavedJobItemsUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data) {
                        savedCount = (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data;
                        dispatch(setState({
                            key: "getModuleHeaderCount",
                            value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                                jobItems: savedCount === null || savedCount === void 0 ? void 0 : savedCount.length
                            })
                        }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    dispatch(setState({
                        key: "getModuleHeaderCount",
                        value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                            jobItems: customerDetailsTrnalsteToJob === null || customerDetailsTrnalsteToJob === void 0 || (_customerDetailsTrnal = customerDetailsTrnalsteToJob.data) === null || _customerDetailsTrnal === void 0 ? void 0 : _customerDetailsTrnal.length
                        })
                    }));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleComplaintData = function (data) {
        addCustomerComplaints(data);
    };
    var jobCardCustomerDetails = function () { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload4, _result$payload5, jobItemURL, requestBody, _documentDetailsGetBy2, result, _result$payload6, savedCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data || documentId)) return [3 /*break*/, 2];
                    jobItemURL = void 0;
                    requestBody = {};
                    if (apiRequestParam == "JobCard") {
                        requestBody.JobCardId = (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.id) || documentId;
                        jobItemURL = getSavedJobItemsJobCardUrl;
                    }
                    else {
                        requestBody.PreJobCardDocumentId = requestID || (preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0].PreJobCardDocumentId);
                        jobItemURL = getSavedJobItemsUrl;
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'customerDetailsTrnalsteToJob',
                            url: jobItemURL,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload4 = result.payload) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.value) !== null && _result$payload4 !== void 0 && _result$payload4.success && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && (_result$payload5 = _result$payload5.value) !== null && _result$payload5 !== void 0 && _result$payload5.data) {
                        savedCount = (_result$payload6 = result.payload) === null || _result$payload6 === void 0 || (_result$payload6 = _result$payload6.value) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.data;
                        dispatch(setState({
                            key: "getModuleHeaderCount",
                            value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                                jobItems: savedCount.length
                            })
                        }));
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var uploadAttachmentUsingId = function (PreJobCardDocumentAttachmentId, data) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UploadImage(getPreJobCardDocumentAttachmentUploadUrl(PreJobCardDocumentAttachmentId), data, 'CustomerVoice', dispatch)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    var addCustomerComplaints = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var _userData$data, _ResponseResult$paylo, key, request, ResponseResult, _ResponseResult$paylo2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _b.sent();
                    key = Object.keys(apiRequestPayload)[0];
                    request = (_a = {},
                        _a[key] = requestID,
                        _a.CustomerComplaint = data.discription,
                        _a.TakenBy = userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId,
                        _a);
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'SaveCustomerComplaints',
                            url: VoiceUrl(apiRequestParam),
                            request: request
                        }))];
                case 2:
                    ResponseResult = _b.sent();
                    if (!(ResponseResult !== null && ResponseResult !== void 0 && (_ResponseResult$paylo = ResponseResult.payload) !== null && _ResponseResult$paylo !== void 0 && (_ResponseResult$paylo = _ResponseResult$paylo.value) !== null && _ResponseResult$paylo !== void 0 && _ResponseResult$paylo.success && (ResponseResult === null || ResponseResult === void 0 ? void 0 : ResponseResult.payload.value.statusCode) === 201)) return [3 /*break*/, 4];
                    // await dispatch(getByIdAPI({ key: "appointmentCount", url: AppointmentJobCountUrl(requestID ?? '') }));
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    // await dispatch(getByIdAPI({ key: "appointmentCount", url: AppointmentJobCountUrl(requestID ?? '') }));
                    _b.sent();
                    createAttachmentId(ResponseResult === null || ResponseResult === void 0 || (_ResponseResult$paylo2 = ResponseResult.payload) === null || _ResponseResult$paylo2 === void 0 || (_ResponseResult$paylo2 = _ResponseResult$paylo2.value) === null || _ResponseResult$paylo2 === void 0 || (_ResponseResult$paylo2 = _ResponseResult$paylo2.data) === null || _ResponseResult$paylo2 === void 0 ? void 0 : _ResponseResult$paylo2.CustomerVoiceId, data);
                    if (disabledConfirmDocument) {
                        disabledConfirmDocument(true);
                    }
                    dispatch(setDocDataUpdated(false));
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Create Attachment Id
    var createAttachmentId = function (custId, data) { return __awaiter(_this, void 0, void 0, function () {
        var _data$audio, ImageAttachmentsBody_1, audioFiles, request, ResponseData, PreJobCardDocumentAttachmentIds, imageAttachmentsWithMediaType1_1, uploadPromises, audioAttachmentsWithMediaType2_1, uploadPromises1, e_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 8]);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    ImageAttachmentsBody_1 = [];
                    if (data.images.length > 0) {
                        data.images.map(function (imageItem) {
                            ImageAttachmentsBody_1.push({
                                SystemName: "CustomerVoice",
                                MediaType: 1
                            });
                        });
                    }
                    audioFiles = Array.isArray(data.audio.audioFile) ? data.audio.audioFile : [data.audio.audioFile];
                    if (data !== null && data !== void 0 && (_data$audio = data.audio) !== null && _data$audio !== void 0 && _data$audio.audioFile) {
                        audioFiles.map(function (audioFile) {
                            ImageAttachmentsBody_1.push({
                                SystemName: "CustomerVoice",
                                MediaType: 2
                            });
                        });
                    }
                    request = {
                        ParentId: custId,
                        ImageAttachments: ImageAttachmentsBody_1
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: precheckAttachmentCreateUrl,
                            request: request
                        }))];
                case 2:
                    ResponseData = _a.sent();
                    PreJobCardDocumentAttachmentIds = [];
                    if (ResponseData.payload.success && ResponseData.payload.data) {
                        PreJobCardDocumentAttachmentIds = ResponseData.payload.data;
                    }
                    imageAttachmentsWithMediaType1_1 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 1; });
                    uploadPromises = data.images.map(function (imageItem, index) { return __awaiter(_this, void 0, void 0, function () {
                        var formData, matchingAttachment, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', imageItem.file);
                                    matchingAttachment = imageAttachmentsWithMediaType1_1[index];
                                    if (!matchingAttachment) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachmentUsingId(matchingAttachment.PreJobCardDocumentAttachmentId, formData)];
                                case 1:
                                    result = _a.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    // Handle the case where there is no matching attachment with MediaType === 1
                                    console.error("No matching attachment found with MediaType === 1");
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 3:
                    _a.sent();
                    audioAttachmentsWithMediaType2_1 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 2; });
                    uploadPromises1 = audioFiles.map(function (audioItem, index) { return __awaiter(_this, void 0, void 0, function () {
                        var formData, matchingAttachment, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', audioItem);
                                    matchingAttachment = audioAttachmentsWithMediaType2_1[index];
                                    if (!matchingAttachment) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachmentUsingId(matchingAttachment.PreJobCardDocumentAttachmentId, formData)];
                                case 1:
                                    result = _a.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    // Handle the case where there is no matching attachment with MediaType === 2
                                    console.error("No matching attachment found with MediaType === 2");
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises1)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 5:
                    _a.sent();
                    customerComplaint(apiRequestPayload, url);
                    renderMainComponent(true);
                    return [3 /*break*/, 8];
                case 6:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseTranslateToJoBitem = function (item) {
        setisTranslateToJobChecked(function (prev) { return !prev; });
        setItemCustomerId(item === null || item === void 0 ? void 0 : item.CustomerVoiceId);
    };
    var handleSaveTrnalateToJob = function (listValue, declinedComplaints) { return __awaiter(_this, void 0, void 0, function () {
        var _getCustomerVoiceSect, filterArrayChecked, filterArrayUnCheckedAlreadySaved, map_1, _customerDetailsTrnal2, savedArray_1, finalArray_1, transformedArray_1, checkComment, profileData, updatedDeclinedJobItems, declinedRequestBodyArray_1, _preDocumentFetch$dat4, _response$payload, _response$payload2, key, request, response, _documentDetailsGetBy5, declinedRequestBody, declinedResult, _repeatAlertConfigura, _repeatAlertConfigura2, _repeatAlertConfigura3, _documentDetailsGetBy6, _documentDetailsGetBy7, _documentDetailsGetBy8, repeatBody, checkRepeatResponse, transformedArray_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!listValue) return [3 /*break*/, 10];
                    filterArrayChecked = listValue.flatMap(function (obj) { return obj.data ? obj.data.filter(function (item) { return item.isCheckBoxClicked; }) : []; });
                    filterArrayUnCheckedAlreadySaved = listValue.flatMap(function (obj) { return obj.data ? obj.data.filter(function (item) { return !item.isCheckBoxClicked && item.isAlreadySaved; }) : []; });
                    map_1 = new Map();
                    if (!savedJobItemCreateFlow) {
                        customerDetailsTrnalsteToJob === null || customerDetailsTrnalsteToJob === void 0 || (_customerDetailsTrnal2 = customerDetailsTrnalsteToJob.data) === null || _customerDetailsTrnal2 === void 0 || _customerDetailsTrnal2.forEach(function (item) {
                            map_1.set(item.ComplaintId, item);
                        });
                    }
                    getStoredJobItems === null || getStoredJobItems === void 0 || getStoredJobItems.forEach(function (item) {
                        map_1.set(item.ComplaintId, item);
                    });
                    savedArray_1 = Array.from(map_1.values());
                    finalArray_1 = [];
                    filterArrayChecked.map(function (checkedItem) {
                        var matchitem = savedArray_1.find(function (savedItem) { return savedItem.ComplaintId === checkedItem.ComplaintId; });
                        if (matchitem) {
                            finalArray_1.push(checkedItem);
                            savedArray_1 = savedArray_1.filter(function (savedItem) { return savedItem.ComplaintId !== matchitem.ComplaintId; });
                        }
                        else {
                            finalArray_1.push(checkedItem);
                        }
                    });
                    filterArrayUnCheckedAlreadySaved.map(function (uncheckedItem) {
                        var _savedArray;
                        var matchItem = (_savedArray = savedArray_1) === null || _savedArray === void 0 ? void 0 : _savedArray.find(function (savedItem) { return savedItem.ComplaintId === uncheckedItem.ComplaintId; });
                        if (matchItem) {
                            var _savedArray2;
                            savedArray_1 = (_savedArray2 = savedArray_1) === null || _savedArray2 === void 0 ? void 0 : _savedArray2.filter(function (savedItem) { return savedItem.ComplaintId !== matchItem.ComplaintId; });
                        }
                    });
                    savedArray_1.map(function (savedItem) {
                        finalArray_1.push(savedItem);
                    });
                    transformedArray_1 = finalArray_1.map(function (obj) {
                        var _obj$Comments;
                        var ImageAttachmentsArray = [];
                        if (obj !== null && obj !== void 0 && obj.images && obj.images.length > 0) {
                            obj.images.map(function (image) {
                                ImageAttachmentsArray.push({
                                    AttachmentId: image.attachmentId,
                                    MediaType: 1,
                                    SystemName: "CustomerVoiceToJobItem"
                                });
                            });
                        }
                        if (obj.audioAttachmentId) {
                            ImageAttachmentsArray.push({
                                AttachmentId: obj.audioAttachmentId,
                                MediaType: 2,
                                SystemName: "CustomerVoiceToJobItem"
                            });
                        }
                        var ComplaintAssociations = [];
                        if (obj.ComplaintChildAssociation) {
                            var _obj$ComplaintChildAs, _obj$ComplaintChildAs2;
                            (_obj$ComplaintChildAs = obj.ComplaintChildAssociation) === null || _obj$ComplaintChildAs === void 0 || (_obj$ComplaintChildAs = _obj$ComplaintChildAs.Part) === null || _obj$ComplaintChildAs === void 0 || _obj$ComplaintChildAs.map(function (partItem) {
                                var _documentDetailsGetBy3;
                                ComplaintAssociations.push({
                                    Quantity: partItem.Quantity,
                                    SystemName: "Product",
                                    ChildId: partItem.ChildId,
                                    ServiceGroupId: obj.ComplaintId,
                                    ServiceTypeId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.RepairTypeId,
                                    ServiceDetailType: 4,
                                    ParentSystemName: apiRequestParam,
                                    Price: null
                                });
                            });
                            (_obj$ComplaintChildAs2 = obj.ComplaintChildAssociation) === null || _obj$ComplaintChildAs2 === void 0 || (_obj$ComplaintChildAs2 = _obj$ComplaintChildAs2.Labour) === null || _obj$ComplaintChildAs2 === void 0 || _obj$ComplaintChildAs2.map(function (labourItem) {
                                var _documentDetailsGetBy4;
                                ComplaintAssociations.push({
                                    Quantity: labourItem.Quantity,
                                    SystemName: "Labour",
                                    ChildId: labourItem.ChildId,
                                    ServiceGroupId: obj.ComplaintId,
                                    ServiceTypeId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.RepairTypeId,
                                    ServiceDetailType: 4,
                                    ParentSystemName: apiRequestParam,
                                    Price: null
                                });
                            });
                        }
                        return {
                            SystemName: obj.SystemName ? obj.SystemName : "CustomerVoiceToJobItem",
                            ComplaintGroupAssociationId: obj.ComplaintGroupAssociationId,
                            ComplaintGroupChildAssociationId: obj.ComplaintGroupChildAssociationId,
                            Value: "1",
                            Comments: (_obj$Comments = obj.Comments) !== null && _obj$Comments !== void 0 ? _obj$Comments : "",
                            ComplaintId: obj.ComplaintId,
                            ImageAttachments: ImageAttachmentsArray,
                            ComplaintAssociations: ComplaintAssociations
                        };
                    });
                    if ((_getCustomerVoiceSect = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect !== void 0 && (_getCustomerVoiceSect = _getCustomerVoiceSect.SA_COMMENTS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect !== void 0 && _getCustomerVoiceSect.MANDATORY) {
                        checkComment = transformedArray_1.every(function (item) { return item.Comments; });
                        if (!checkComment) {
                            profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', t('SA_COMMENTS_MANDATORY_ERROR'));
                            dispatch(showNotification({
                                isOpen: true,
                                message: t('SA_COMMENTS_MANDATORY_ERROR'),
                                type: "error"
                            }));
                            return [2 /*return*/];
                        }
                    }
                    updatedDeclinedJobItems = declinedComplaints.filter(function (item) { return !transformedArray_1.some(function (transformedItem) { return transformedItem.ComplaintId === item.ComplaintId; }); });
                    declinedRequestBodyArray_1 = [];
                    updatedDeclinedJobItems.map(function (declinedItem) {
                        declinedRequestBodyArray_1.push({
                            SystemName: declinedItem.SystemName,
                            ComplaintGroupAssociationId: declinedItem.ComplaintGroupAssociationId,
                            ComplaintGroupChildAssociationId: declinedItem.ComplaintGroupChildAssociationId,
                            ComplaintAssociations: [],
                            Comments: declinedItem.Comments,
                            ComplaintId: declinedItem.ComplaintId,
                            DeclinedJobReasonId: declinedItem.DeclinedJobReasonId,
                            Remarks: declinedItem.Remarks,
                            Value: declinedItem.Value,
                            ImageAttachments: declinedItem.ImageAttachments ? declinedItem.ImageAttachments : []
                        });
                    });
                    if (!(!IsFromParentAPt && ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) == 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) == 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) == 'Update'))) return [3 /*break*/, 8];
                    key = Object.keys(apiRequestPayload)[0];
                    request = (_a = {},
                        _a[key] = requestID,
                        _a.JobItems = transformedArray_1,
                        _a);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: CustomerVoiceToJobItemUrl(apiRequestParam),
                            request: request
                        }))];
                case 2:
                    response = _b.sent();
                    if (!(requestID || preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat4 = preDocumentFetch.data[0]) !== null && _preDocumentFetch$dat4 !== void 0 && _preDocumentFetch$dat4.PreJobCardDocumentId)) return [3 /*break*/, 4];
                    declinedRequestBody = {
                        PreJobCardDocumentId: requestID || (preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0].PreJobCardDocumentId),
                        InstallBaseId: (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.InstallBaseId,
                        DeclinedJobItems: declinedRequestBodyArray_1
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: saveDeclinedCustomerComplaintsUrl,
                            request: declinedRequestBody
                        }))];
                case 3:
                    declinedResult = _b.sent();
                    _b.label = 4;
                case 4: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 5:
                    _b.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success || (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) == 200)) return [3 /*break*/, 7];
                    dispatch(setState({
                        key: "customerDetailsTrnalsteToJob",
                        value: {
                            success: true,
                            data: finalArray_1
                        }
                    }));
                    setisTranslateToJobChecked(function (prev) { return !prev; });
                    dispatch(setState({
                        key: "getModuleHeaderCount",
                        value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                            jobItems: finalArray_1.length
                        })
                    }));
                    dispatch(setState({
                        key: "savedJobItemClick",
                        value: true
                    }));
                    if (!(repeatAlertConfiguration !== null && repeatAlertConfiguration !== void 0 && (_repeatAlertConfigura = repeatAlertConfiguration.data) !== null && _repeatAlertConfigura !== void 0 && _repeatAlertConfigura.Transaction && Array.isArray(repeatAlertConfiguration === null || repeatAlertConfiguration === void 0 || (_repeatAlertConfigura2 = repeatAlertConfiguration.data) === null || _repeatAlertConfigura2 === void 0 ? void 0 : _repeatAlertConfigura2.Transaction) && repeatAlertConfiguration !== null && repeatAlertConfiguration !== void 0 && (_repeatAlertConfigura3 = repeatAlertConfiguration.data) !== null && _repeatAlertConfigura3 !== void 0 && _repeatAlertConfigura3.Transaction.includes(SystemName))) return [3 /*break*/, 7];
                    repeatBody = {
                        "InstallBaseId": (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.InstallBaseId,
                        "CurrentODOMeterReading": (_documentDetailsGetBy7 = documentDetailsGetById.data) === null || _documentDetailsGetBy7 === void 0 ? void 0 : _documentDetailsGetBy7.ODOMeterReading,
                        "CurrentJobCardDate": moment().startOf('day'),
                        "CurrentJobCardParentOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        "CurrentJobCardOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "CurrentJobCardRepairTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy8 = documentDetailsGetById.data) === null || _documentDetailsGetBy8 === void 0 ? void 0 : _documentDetailsGetBy8.RepairTypeId,
                        "ParentId": requestID || (preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0].PreJobCardDocumentId),
                        "CurrentComplaints": transformedArray_1.map(function (item) { return item.ComplaintId; }),
                        "CurrentParts": [],
                        "CurrentLabours": []
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            url: CheckRepeatUrl,
                            request: repeatBody
                        }))];
                case 6:
                    checkRepeatResponse = _b.sent();
                    _b.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, getJobItemsTranslateToJobItems(finalArray_1)];
                case 9:
                    transformedArray_2 = _b.sent();
                    dispatch(setState({
                        key: "getModuleHeaderCount",
                        value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                            jobItems: transformedArray_2.length
                        })
                    }));
                    dispatch(setState({
                        key: "getStoredJobItems",
                        value: transformedArray_2
                    }));
                    dispatch(setState({
                        key: "savedJobItemClick",
                        value: true
                    }));
                    dispatch(setState({
                        key: "savedJobItemCreateFlow",
                        value: true
                    }));
                    setisTranslateToJobChecked(function (prev) { return !prev; });
                    _b.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var getDownloadImage = function (index) { return __awaiter(_this, void 0, void 0, function () {
        var updateList, updateItem, imageAttachementURLs, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, downloadPromise, audioAttachmentsUrlWithMediaType2, downloadPromise1, error_1, sortedImages, error_2;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    updateList = __spreadArray([], list, true);
                    updateItem = _objectSpread({}, updateList[index]);
                    if (updateItem !== null && updateItem !== void 0 && updateItem.imageAttachementURLs && (updateItem === null || updateItem === void 0 ? void 0 : updateItem.imageAttachementURLs.length) > 0 || updateItem.audioAttachementURLs && updateItem.audioAttachementURLs.length > 0) {
                        updateItem.isExpanded = true;
                        updateList[index] = updateItem;
                        setList(updateList);
                        return [2 /*return*/];
                    }
                    imageAttachementURLs = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1 = updateItem.ImageAttachment.filter(function (item) { return item.MediaType === 1; });
                    downloadPromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                        var base64, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    imageAttachementURLs.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        base64: base64
                                    }));
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error(error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    audioAttachmentsUrlWithMediaType2 = updateItem.ImageAttachment.filter(function (item) { return item.MediaType === 2; });
                    downloadPromise1 = audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                        var base64, error_4;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push(base64);
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_4 = _a.sent();
                                    console.error(error_4);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.all(downloadPromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadPromise1)];
                case 3:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5:
                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs);
                    updateItem.imageAttachementURLs = sortedImages.map(function (item) { return item.base64; });
                    updateItem.audioAttachementURLs = audioAttachementURLs;
                    updateItem.isExpanded = true;
                    updateList[index] = updateItem;
                    setList(updateList);
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error("CustomerComplaintView :: getDownloadImageError :: ", error_2);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var customerComplaint = function (request, customerComplaintUrl) { return __awaiter(_this, void 0, void 0, function () {
        var _response$payload3, _response$payload4, response, _response$payload5, _response$payload6, finalList, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 7]);
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'CustomerComplaintList',
                            url: customerComplaintUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload3 = response.payload) !== null && _response$payload3 !== void 0 && (_response$payload3 = _response$payload3.value) !== null && _response$payload3 !== void 0 && _response$payload3.statusCode && response !== null && response !== void 0 && (_response$payload4 = response.payload) !== null && _response$payload4 !== void 0 && (_response$payload4 = _response$payload4.value) !== null && _response$payload4 !== void 0 && _response$payload4.data)) return [3 /*break*/, 2];
                    if ((response === null || response === void 0 || (_response$payload5 = response.payload) === null || _response$payload5 === void 0 || (_response$payload5 = _response$payload5.value) === null || _response$payload5 === void 0 || (_response$payload5 = _response$payload5.data) === null || _response$payload5 === void 0 ? void 0 : _response$payload5.CustomerVoice.length) > 0) {
                        finalList = response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.value) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.data) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.CustomerVoice.map(function (list) {
                            var imageAttachementURLs = [];
                            return _objectSpread(_objectSpread({}, list), {}, {
                                imageAttachementURLs: imageAttachementURLs,
                                isExpanded: false
                            });
                        });
                        setList(finalList);
                        // await dispatch(showLoader({ isLoaderOpen: true }));
                        // await dispatch(showLoader({ isLoaderOpen: false }));
                    }
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5:
                    error_5 = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 6:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var customerComplaintJobcard = function (request, customerComplaintUrl) { return __awaiter(_this, void 0, void 0, function () {
        var _response$payload7, _response$payload8, response, _response$payload9, _response$payload10, finalList, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 7]);
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'CustomerComplaintList',
                            url: customerComplaintUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload7 = response.payload) !== null && _response$payload7 !== void 0 && (_response$payload7 = _response$payload7.value) !== null && _response$payload7 !== void 0 && _response$payload7.statusCode && response !== null && response !== void 0 && (_response$payload8 = response.payload) !== null && _response$payload8 !== void 0 && (_response$payload8 = _response$payload8.value) !== null && _response$payload8 !== void 0 && _response$payload8.data)) return [3 /*break*/, 2];
                    if ((response === null || response === void 0 || (_response$payload9 = response.payload) === null || _response$payload9 === void 0 || (_response$payload9 = _response$payload9.value) === null || _response$payload9 === void 0 || (_response$payload9 = _response$payload9.data) === null || _response$payload9 === void 0 ? void 0 : _response$payload9.CustomerVoice.length) > 0) {
                        finalList = response === null || response === void 0 || (_response$payload10 = response.payload) === null || _response$payload10 === void 0 || (_response$payload10 = _response$payload10.value) === null || _response$payload10 === void 0 || (_response$payload10 = _response$payload10.data) === null || _response$payload10 === void 0 ? void 0 : _response$payload10.CustomerVoice.map(function (list) {
                            var imageAttachementURLs = [];
                            return _objectSpread(_objectSpread({}, list), {}, {
                                imageAttachementURLs: imageAttachementURLs,
                                isExpanded: false
                            });
                        });
                        setList(finalList);
                    }
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5:
                    error_6 = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 6:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var getImagesLength = function (item) {
        var _item$ImageAttachment;
        var imageAttachmentsUrlWithMediaType1 = item.ImageAttachment ? (_item$ImageAttachment = item.ImageAttachment) === null || _item$ImageAttachment === void 0 ? void 0 : _item$ImageAttachment.filter(function (item) { return item.MediaType === 1; }) : [];
        return imageAttachmentsUrlWithMediaType1.length;
    };
    var getAudioLength = function (item) {
        var audioAttachmentsUrlWithMediaType2 = item.ImageAttachment ? item.ImageAttachment.filter(function (item) { return item.MediaType === 2; }) : [];
        return audioAttachmentsUrlWithMediaType2.length;
    };
    // const handleClickMessageIcon = () => {
    //     setOpenSACommentsPopup(prev => !prev)
    // }
    var handleTranslateToJobMessageClick = function (items) {
        var customerComplaintItem = __spreadArray([], list, true);
        var showMessageClick = customerComplaintItem.map(function (item) { return item.CustomerVoiceId === items.CustomerVoiceId ? _objectSpread(_objectSpread({}, item), {}, {
            isMessageClick: !item.isMessageClick
        }) : item; });
        setList(showMessageClick);
    };
    var handleClose = function (items) {
        setImageURL("");
        setISDrawerOpen(false);
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    var renderImageAudioComponent = function () {
        var show = false;
        if (Module === isModuleConfig.Bajaj) {
            show = true;
        }
        else if (Module === isModuleConfig.Product && apiRequestParam !== APISchema.Jobcard) {
            show = true;
        }
        if (show) {
            return /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12
            }, /*#__PURE__*/ React.createElement(ImageAudioComponent, {
                onDataReceived: handleComplaintData,
                MaxLength: 1000,
                isDisabled: isDisabled,
                createAndEditFlow: createAndEditFlow,
                jobItemClick: function () {
                    setisTranslateToJobChecked(function (prev) { return !prev; });
                },
                listOfCustomerVoice: list,
                vehicleList: vehicleList,
                apiRequestParam: apiRequestParam,
                apiRequestPayload: apiRequestPayload,
                parentModuleDocumentId: parentModuleDocumentId,
                IsFromParentAPt: IsFromParentAPt,
                jobItemClickViewJobs: function () {
                    setisTranslateToJobCheckedViewJobs(function (prev) { return !prev; });
                }
            }));
        }
        return null;
    };
    var renderComponent = function () {
        return /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: 2,
            justifyContent: "center",
            alignItems: "center"
        }, renderImageAudioComponent(), Module == isModuleConfig.Product && /*#__PURE__*/ React.createElement(React.Fragment, null, list && list.length > 0 ? list === null || list === void 0 ? void 0 : list.map(function (item, index) {
            var _item$imageAttachemen, _getCustomerVoiceSect2, _getCustomerVoiceSect3;
            return /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                key: "AppointmentCustomerComplaint" + index,
                rowSpacing: 1
            }, /*#__PURE__*/ React.createElement(Accordion, {
                id: "taken-by-accordian ".concat(index),
                onChange: function (event, expanded) {
                    if (expanded) {
                        getDownloadImage(index);
                    }
                    else {
                        var updatedList = __spreadArray([], list, true);
                        var updatedItem = _objectSpread({}, updatedList[index]);
                        updatedItem.isExpanded = false;
                        updatedList[index] = updatedItem;
                        setList(updatedList);
                    }
                },
                expanded: item.isExpanded,
                style: {
                    width: '100%',
                    border: '1px solid #DEE4EB',
                    boxShadow: 'none',
                    borderRadius: 8
                }
            }, /*#__PURE__*/ React.createElement(AccordionSummary, {
                expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                    id: "expand-customer-voices"
                }),
                "aria-controls": "panel1a-content",
                id: "customer-voices",
                sx: {
                    flexDirection: 'row-reverse',
                    "&.Mui-expanded": {
                        borderBottom: '1px solid #DEE4EB'
                    }
                }
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                spacing: 1,
                paddingLeft: 1,
                width: '100%'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: "space-between",
                alignItems: "center",
                spacing: 0.5
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                alignItems: "center",
                gap: 1
            }, /*#__PURE__*/ React.createElement(FeaturedIconNew, {
                sx: {
                    stroke: systemColor.primary
                }
            }), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h4"
            }, t("Taken by"), " ", /*#__PURE__*/ React.createElement("b", {
                id: "advisor-name"
            }, item.GivenName ? item.GivenName : "", " ", item.FamilyName ? item.FamilyName : ""))), /*#__PURE__*/ React.createElement(MuiStack, {
                spacing: 1
            }, getImagesLength(item) > 0 && /*#__PURE__*/ React.createElement("img", {
                height: '18px',
                src: MovieCreationIcon,
                alt: "moviecreation"
            }), getAudioLength(item) > 0 && /*#__PURE__*/ React.createElement("img", {
                height: '18px',
                src: gramophoneIcon,
                alt: "gramaphone"
            }))), /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 1
            }, /*#__PURE__*/ React.createElement(Img, {
                src: CalendarIconNew,
                alt: "settingIcon"
            }), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h4",
                id: "recorded-data-time"
            }, dateFormate(item.RecordedDateTime), " ", getTime(item.RecordedDateTime), " ")))), /*#__PURE__*/ React.createElement(AccordionDetails, {
                sx: {
                    borderBottom: '1px solid #DEE4EB'
                }
            }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h4",
                sx: {
                    color: '#8593A3',
                    wordBreak: 'break-all'
                }
            }, item === null || item === void 0 ? void 0 : item.CustomerComplaint)), /*#__PURE__*/ React.createElement(MuiStack, {
                paddingY: 1
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'space-between',
                display: 'flex',
                alignItems: "center"
            }, item === null || item === void 0 || (_item$imageAttachemen = item.imageAttachementURLs) === null || _item$imageAttachemen === void 0 ? void 0 : _item$imageAttachemen.map(function (img, idx) {
                /*#__PURE__*/
                // <Grid xs={4} sm={1.5} md={2} lg={1.5}>
                return React.createElement(MuiStack, {
                    justifyContent: "space-between"
                }, /*#__PURE__*/ React.createElement("div", {
                    style: {
                        position: 'relative'
                    }
                }, /*#__PURE__*/ React.createElement("img", {
                    src: img,
                    id: "downloadCustomerImg" + idx,
                    alt: "Image ".concat(idx + 1),
                    style: {
                        width: '82px',
                        height: '82px',
                        borderRadius: '8px',
                        position: 'relative'
                    },
                    onClick: function () { return handleClickImage(img); }
                })));
            }
            // </Grid>
            ))), /*#__PURE__*/ React.createElement(ViewAllImagePopUp, {
                isOpen: viewImages,
                onClosed: function () { return setViewImages(function (prev) { return !prev; }); },
                images: item === null || item === void 0 ? void 0 : item.imageList
            }), (item === null || item === void 0 ? void 0 : item.audioAttachementURLs) && (item === null || item === void 0 ? void 0 : item.audioAttachementURLs.length) > 0 && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                paddingTop: '16px'
            }, /*#__PURE__*/ React.createElement(AudioPlayer, {
                src: item === null || item === void 0 ? void 0 : item.audioAttachementURLs,
                isSlider: true,
                audioDuration: 0
            }))), /*#__PURE__*/ React.createElement(AccordionDetails, null, /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'space-between',
                paddingTop: 1
            }, !isDisabled ? /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'flex-end',
                onClick: function () { return handleCloseTranslateToJoBitem(item); },
                sx: {
                    ":hover": {
                        cursor: "pointer"
                    }
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h2",
                id: "translateToJobItem",
                sx: {
                    fontSize: "14px",
                    color: systemColor.primary,
                    cursor: 'pointer'
                }
            }, (_getCustomerVoiceSect2 = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect2 !== void 0 && (_getCustomerVoiceSect2 = _getCustomerVoiceSect2.JOB_ITEMS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect2 !== void 0 && _getCustomerVoiceSect2.MANDATORY ? t("Translate to job items") + "*" : t("Translate to job items")), /*#__PURE__*/ React.createElement(Typography, {
                style: {
                    borderRadius: '20px',
                    border: '1px solid #AFD5FF',
                    width: (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems) > 99 ? '33px' : '23px',
                    height: '22px',
                    marginLeft: '10px',
                    backgroundColor: '#EEF6FF'
                },
                align: "center",
                color: "#AFD5FF"
            }, getModuleHeaderCount && (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems))) : /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'flex-end',
                sx: {
                    ":hover": {
                        cursor: "pointer"
                    }
                },
                onClick: function () {
                    setisTranslateToJobCheckedViewJobs(function (prev) { return !prev; });
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h2",
                id: "translateToJobItem",
                sx: {
                    color: systemColor.primary,
                    cursor: 'pointer'
                }
            }, t("View jobs")), /*#__PURE__*/ React.createElement(Typography, {
                style: {
                    borderRadius: '20px',
                    border: '1px solid #AFD5FF',
                    width: (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems) > 99 ? '33px' : '25px',
                    height: '25px',
                    marginLeft: '10px',
                    backgroundColor: '#EEF6FF'
                },
                align: "center",
                color: "#AFD5FF"
            }, getModuleHeaderCount && (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems))), customerVoiceSectionDetails && !((_getCustomerVoiceSect3 = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect3 !== void 0 && (_getCustomerVoiceSect3 = _getCustomerVoiceSect3.OVERALL_COMMENTS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect3 !== void 0 && _getCustomerVoiceSect3.HIDE) && /*#__PURE__*/ React.createElement(IconButton, {
                style: {
                    padding: 0
                },
                onClick: function () { return handleTranslateToJobMessageClick(item); }
            }, /*#__PURE__*/ React.createElement(MoreClickIconSVG, {
                sx: {
                    color: systemColor.primary
                },
                id: "settingIcon"
            })), item.isMessageClick && /*#__PURE__*/ React.createElement(TranslateToJobMessage, {
                isOpen: item.isMessageClick,
                onClickMsgIcon: function () { return handleTranslateToJobMessageClick(item); },
                data: {
                    imageList: []
                } // onClickMsgIcon={handleMessageIcon} 
                ,
                customerComplaintId: item.CustomerVoiceId // data={jobItemData} 
                ,
                handleDataBack: function () { return handleTranslateToJobMessageClick(item); },
                setIsOpen: setOpenSACommentsPopup,
                parentModuleDocumentId: parentModuleDocumentId !== null && parentModuleDocumentId !== void 0 ? parentModuleDocumentId : "",
                apiRequestParam: apiRequestParam,
                apiRequestPayload: apiRequestPayload,
                parentComponent: ESABoxParent.CustomerComplaint,
                isViewOnly: isDisabled,
                isFromJobCard: apiRequestParam == APISchema.Jobcard
            })))));
        }) : /*#__PURE__*/ React.createElement(Grid, {
            item: true
        })), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
            isOpen: isDrawerOpen,
            onClose: handleClose,
            image: imageURL
        }), isTranslateToJobClicked && !isDisabled && /*#__PURE__*/ React.createElement(TranslateToJobComponent, {
            vehicleList: vehicleList,
            requestID: requestID,
            isOpen: isTranslateToJobClicked,
            onClose: function () { return setisTranslateToJobChecked(function (prev) { return !prev; }); },
            handleSave: function (listValue, declinedItems) { return handleSaveTrnalateToJob(listValue, declinedItems); },
            isDisabled: isDisabled,
            filterSystemName: "CustomerVoiceToJobItem"
        }), isTranslateToJobClickedViewJObs && /*#__PURE__*/ React.createElement(VehicleDetailsViewJobs, {
            isOpen: isTranslateToJobClickedViewJObs,
            onClose: function () { return setisTranslateToJobCheckedViewJobs(function (prev) { return !prev; }); },
            listItem: list,
            title: t('Job items'),
            customerVoiceId: itemCustomerId,
            isFromJobCard: apiRequestParam == APISchema.Jobcard,
            SystemName: apiRequestParam,
            requestID: requestID
        }));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showInAccordian ? /*#__PURE__*/ React.createElement(CustomeAccordian, {
        id: "customerComplaintAccordian",
        title: t("Customer voice"),
        listLength: customerDetailsTrnalsteToJob && (customerDetailsTrnalsteToJob === null || customerDetailsTrnalsteToJob === void 0 || (_customerDetailsTrnal3 = customerDetailsTrnalsteToJob.data) === null || _customerDetailsTrnal3 === void 0 ? void 0 : _customerDetailsTrnal3.length),
        icon: "",
        isFromAppointment: true,
        handleClick: function () { return customerComplaint(apiRequestPayload, url); },
        addDisable: addClick,
        disableIcon: PlusGrayIconNew,
        isDisabled: isDisabled
    }, renderComponent()) : /*#__PURE__*/ React.createElement(React.Fragment, null, renderComponent()));
}
